export const intToFloat = (int: number | null): number | null => {
  if (!int) return null;
  return Math.round((parseFloat(int.toString()) / 100) * 100) / 100;
};

export const floatToInt = (float: number): number => Math.round(float * 100);

export const getDigitsInfo = (value: number): string => (value % 100 === 0 ? "1.0-0" : "1.2-2");
